import { Controller } from "@hotwired/stimulus"

/**
 * CONEK-9158 — the leg history drawer's filter groups follow the row type.
 *
 * The drawer renders the dependent groups (Severity, Event status, Outcome,
 * Inspection status — Outcome only when the leg has outcomes to offer), each
 * a native <fieldset> `group` target carrying the kind that owns it in
 * `data-kind` ("events" or "walks"). Choosing a row type in the kind <select>
 * shows the groups that kind owns and hides the rest WITHOUT a reload; All and
 * Device changes only own none.
 *
 * A hidden group is also DISABLED, on the fieldset itself: a disabled
 * fieldset disables every control inside it, so a hidden group submits
 * nothing — a control the reader cannot see must never narrow the list — and
 * a control the multi-select adds later is covered without this controller
 * knowing about it. The server renders the same state for the kind it was
 * asked for (index.html.erb), and `connect` re-applies it, so the drawer is
 * right whichever runs first.
 *
 * data-controller="iot--leg-history-filters" on the form; the kind select
 * (Ui::SelectComponent's native <select name="kind">, whose `change` Tom
 * Select fires) carries data-action="change->iot--leg-history-filters#toggle".
 */
export default class extends Controller {
  static targets = ["group"]

  connect() {
    this.toggle()
  }

  toggle() {
    const select = this.element.querySelector('select[name="kind"]')
    const kind = select ? select.value : ""

    this.groupTargets.forEach((group) => {
      const owned = group.dataset.kind === kind
      group.classList.toggle("hidden", !owned)
      group.disabled = !owned
    })
  }
}
